var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.orphan") } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c(
              "div",
              { staticClass: "mb-3", attrs: { slot: "fixed" }, slot: "fixed" },
              [
                _c(
                  "div",
                  { staticClass: "position-absolute top-44px w-100" },
                  [
                    _vm.serviceId === _vm.services.PAYMENTS && _vm.mode === 2
                      ? _c("cm-messages-filter", {
                          staticClass: "researchfilter position-relative z-10",
                          attrs: {
                            isPayments: "",
                            received: "",
                            filterType: "group",
                            mode: this.mode,
                          },
                          on: {
                            extractCSV: function ($event) {
                              return _vm.extractCSV(_vm.inboxMessages)
                            },
                            applyFilter: function ($event) {
                              return _vm.applyFilter($event)
                            },
                            refreshInbox: function ($event) {
                              return _vm.refreshInbox()
                            },
                          },
                        })
                      : _c("cm-messages-filter", {
                          staticClass: "researchfilter position-relative z-10",
                          attrs: {
                            isPayments: "",
                            received: "",
                            filterType: "list",
                            mode: this.mode,
                          },
                          on: {
                            extractCSV: function ($event) {
                              return _vm.extractCSV(_vm.inboxMessages)
                            },
                            applyFilter: function ($event) {
                              return _vm.applyFilter($event)
                            },
                            refreshInbox: function ($event) {
                              return _vm.refreshInbox()
                            },
                          },
                        }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage" },
          [
            false
              ? _c(
                  "b-row",
                  { staticClass: "form-group justify-content-start" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            attrs: { disabled: _vm.activateSpinner },
                            on: {
                              click: function ($event) {
                                return _vm.refreshInbox()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-light fa-rotate-right",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("common.rfrsh"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "1", "offset-md": "6" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled: _vm.activateSpinner,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.extractCSV()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-upload" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("common.extract"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _vm.serviceId === _vm.services.PAYMENTS &&
                              _vm.mode === 2
                                ? _c("cm-messages-filter", {
                                    staticClass:
                                      "researchfilter position-relative z-10",
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "group",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                      propedServiceId: "1",
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                      refreshInbox: function ($event) {
                                        return _vm.refreshInbox()
                                      },
                                    },
                                  })
                                : _c("cm-messages-filter", {
                                    staticClass:
                                      "researchfilter position-relative z-10",
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "list",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                      propedServiceId: "1",
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                      refreshInbox: function ($event) {
                                        return _vm.refreshInbox()
                                      },
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { class: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner", { staticClass: "mt-3" })
                      : _c(
                          "div",
                          [
                            _vm.items.length
                              ? _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.results_payments_desc") +
                                          _vm.paginationObject.nbResultsTotal
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.items.length
                              ? _c("b-table", {
                                  key: _vm.keyTableFlux,
                                  staticClass: "mt-3 table-striped",
                                  attrs: {
                                    relative: "",
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(direction)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cursor text-ellipsis",
                                              },
                                              [
                                                data.value === "0"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "direction-received",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.rcvd"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "direction-sent",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("common.snt")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(dateTime)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "text-ellipsis" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      data.value
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(clearing)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-ellipsis",
                                                class:
                                                  _vm.getClearingTitleColor(
                                                    data.value
                                                  ),
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    data.value
                                                      ? data.value
                                                      : _vm.$t(
                                                          "filter.orphan.clearing.undefined"
                                                        )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(msgType)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "text-ellipsis" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getMessageTypeLabel(
                                                      data.value
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(flow)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-xl-flex align-items-center justify-content-center",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(data.value)),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.seeXml(
                                                          {
                                                            id: data.item
                                                              .idFormatIn,
                                                            type: data.value,
                                                          },
                                                          data.item.msgType ===
                                                            "5"
                                                            ? "payment"
                                                            : "requestToPay",
                                                          "see"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.seeXml(
                                                          {
                                                            id: data.item
                                                              .idFormatIn,
                                                            type: data.value,
                                                          },
                                                          data.item.msgType ===
                                                            "5"
                                                            ? "payment"
                                                            : "requestToPay",
                                                          "download"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3836452130
                                  ),
                                })
                              : _c(
                                  "label",
                                  {
                                    staticClass:
                                      "font-bold w-100 d-flex justify-content-center mt-3",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.no_result")))]
                                ),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("cm-pagination", {
                                  attrs: {
                                    maxResultsByPage:
                                      _vm.paginationObject.maxResults,
                                    firstIndex: _vm.paginationObject.firstIndex,
                                    nbResultsTotal:
                                      _vm.paginationObject.nbResultsTotal,
                                    refreshEvent: _vm.paginationObject.refresh,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }